import { createBrowserHistory } from 'history';

export const history = createBrowserHistory({ window });

export const getSearchParams = () => {
  return getFormattedSearchRoot();
};

export const getFormattedSearchRoot = () => {
  const { search: query } = history.location;
  return formatQuery(query);
};

export const formatQuery = (query) => {
  if (query === '') return {};
  const url = query;
  const regex = /[?&]([\w-]+)=([\w%+-]+)/g;
  const params = {};
  let match;
  while ((match = regex.exec(url)) !== null) {
    const paramName = match[1];
    params[paramName] = decodeURIComponent(match[2]);
  }
  return params;
};

export const TransformQueryToBoolean = (query) => {
  if (query !== 'true' && query !== 'false') return query;
  if (query === 'true') return true;
  if (query === 'false') return false;
  return undefined;
};
